export const EnrollPaths = {
  root: 'enroll',
  children: {
    signUp: {
      path: 'sign-up',
    },
    confirmEmailSent: {
      path: 'confirm-email-sent',
    },
    confirmEmail: {
      path: 'confirm-email',
    },
    phoneNumber: {
      path: 'phone-number',
    },
    phoneOtp: {
      path: 'phone-otp',
    },
    personalDetails: {
      path: 'personal-details',
    },
    taxDetails: {
      path: 'tax-details',
    },
    addresses: {
      path: 'addresses',
    },
    purposeOfTrading: {
      path: 'purpose-of-trading',
    },
    employmentStatus: {
      path: 'employment-status',
    },
    sourceOfFunds: {
      path: 'source-of-funds',
    },
    estimatedWorth: {
      path: 'estimated-worth',
    },
    financialExperience: {
      path: 'financial-experience',
    },
    financialKnowledge: {
      path: 'financial-knowledge',
    },
    proofOfIdentity: {
      path: 'proof-of-identity',
    },
    proofOfAddress: {
      path: 'proof-of-address',
    },
    termsAndConditions: {
      path: 'terms-and-conditions',
    },
    investmentAccountSetUp: {
      path: 'investment-account-set-up',
    }
  },
};
